// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"manager__wrapper__2MBgQ","popupTitle":"manager__popupTitle__35Ct0","buttonBox":"manager__buttonBox__2cnzN","button":"manager__button__rV-xR"};